import { LitElement, html } from "lit-element";
import { connect } from "pwa-helpers/connect-mixin.js";
import { store } from "../inspx-store.js";
import { updateCurrentInspection, deleteDrawingById, deletePhotoById } from "../actions/inspection.js";
import "./drawing/inspx-drawing-tool.js";
import { close, brush, accountBox, download, description } from "../styles/icons.js";
import { deleteIcon } from "./drawing/Resources/drawing-icons.js";
import { colorTheme } from "../styles/color-theme.js";
import { InspxDialog } from "../elements/inspx-dialog.js";
import { ImageSettingsPopup } from "../elements/inspx-image-settings-popup.js";
import { SharedStyles } from "../styles/shared-styles.js";

class InspPhotoViewer extends connect(store)(LitElement) {
	render() {

		let hideDownloadRemoteDrawing = !this.isRemote || !this.drawing

		return html`
        ${colorTheme}
        ${SharedStyles}
        <style>
            :host {
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100vh;
                background-color: white;
                z-index: 9998;
            }
        
            .container {
                width: 100%;
                height: calc(100% - 60px);
                position: relative;
                /* @apply --layout-horizontal; */
                display: flex;
                background-color: black;
                background-size: contain;
                background-position: center center;
                background-repeat: no-repeat;
            }
        
            .toolbar {
                color: white;
                padding-right: 10px;
                align-items: center;
                height: 60px;
                background-color: var(--primary-color);
                display: flex;
                justify-content: space-between;
                fill: #fff;
                /* @apply --layout-horizontal;
                @apply --layout-justified; */
            }

            .toolbar div {
                display: flex;
            }

            .cover-label {
                display: inline-block;
                position: absolute;
                top: -3px;
                right: 5px;
                color: white;
                padding: 2px 5px;
                font-size: smaller;
                background-color: var(--secondary-color);
            }

            .toolbar div div {
                margin: 0 18px;
            }

            .download svg {
                margin-top: 3px;
            }
            
            mwc-button {
                --mdc-theme-on-primary: var(--primary-color);
                --mdc-theme-primary: var(--primary-color-variant1);
                --mdc-theme-on-secondary: var(--primary-color);
                --mdc-theme-secondary: var(--primary-color-variant1);
            }

            *[active] {
                background-color: var(--secondary-color);                     
            }

            .icons-wrapper {
                display: flex;
                align-items: center;
            }
        </style>
        
        <div class="toolbar">
            <div>
                <div @click="${() => this._close()}" title="close">${close}</div>
            </div>

            <div ?hidden="${hideDownloadRemoteDrawing}">
                <div  class="download"  @click="${() => this._downloadDrawingData()}">${download}</div>
            </div>
           
            <div ?hidden="${this.isRemote}">
                <mwc-button title="Include in the Report"
                    ?active="${!this.notInReportImages || !this.notInReportImages.includes(this.imgId)}" 
                    @click="${e => this._toggleReport(e)}" >${this._getButtonText()}</mwc-button>
                <div class="icons-wrapper">
					${this.drawing && this.name === 'signature' ? '' : html`
                    <div class="download" @click="${() => this._download()}" title="download">${download}</div>
                    <div @click="${() => this._editDescription()}" title="edit description">${description}</div>
                    <div @click="${() => this._setAsCover()}" title="set as cover">${accountBox}</div>
                    <div @click="${() => this._draw()}" title="edit in drawing">${brush}</div>
					`}
                    <div @click="${() => this._delete()}" title="delete">${deleteIcon}</div>
                </div>
            </div>
        </div>
        <div class="container" style="background-image: url(${this.url})">
            <div class="cover-label" ?hidden="${!this.cover}">cover</div>
        </div>`;
	}
    
	_getButtonText() {
		if (!this.notInReportImages || !this.notInReportImages.includes(this.imgId)) {
			return "In report";
		}
		return "Not in report";
	}

	static get properties() {
		return {
			url: { type: String },
			imgId: { type: String },
			drawing: { type: Boolean },
			cover: { type: Boolean },
			notInReportImages: { type: Array },
			name: { type: String },
			description: { type: String },
			applyFunc: { type: Function },
			isRemote: { type: Boolean }
		};
	}

	constructor() {
		super();
		this.__keyDown = this._keyDown.bind(this);
	}

	connectedCallback() {
		super.connectedCallback();
		document.addEventListener('keydown', this.__keyDown);
		document.body.classList.add('freeze-scroll');   
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		document.removeEventListener('keydown', this.__keyDown);
		document.body.classList.remove('freeze-scroll');
	}

	_keyDown(e) {
		if (e.keyCode === 27) {
			this.popupOpen 
				? this.popup.closeFunc()
				: this.remove();
		}
	}

	_close() {
		this.remove();
	}

	_editDescription() {
		this.popupOpen = true
		this.popup = new ImageSettingsPopup(this.name, this.description, this.imgId, this.applyFunc, this.drawing);
		this.popup.applyCallback = (name, description) => {
			this.name = name;
			this.description = description;
		};
		this.popup.closeCallback = () => {
			this.popupOpen = false;
		};
		document.body.appendChild(this.popup);
	}

	_toggleReport() {
		if (!this.notInReportImages || !this.notInReportImages.length) {
			this.notInReportImages = [this.imgId]
		} else {
			!this.notInReportImages.includes(this.imgId)
				? this.notInReportImages.push(this.imgId)
				: this.notInReportImages.splice(this.notInReportImages.indexOf(this.imgId), 1)
		}
		store.dispatch(
			updateCurrentInspection({ path: "not_in_report_images", value: this.notInReportImages })
		).then(() => this.requestUpdate())
	}
    
	_downloadDrawingData(){
		let d = INSP.APP.state.inspection.remote.drawings.find(x=>x.id == this.imgId);
		if(d){
			const data = this.encode(d.drawing);

			const blob = new Blob([data], { type: 'application/octet-stream' });
			const url = URL.createObjectURL(blob);
			var link = document.createElement('a');
			link.setAttribute('href', url);
			link.setAttribute('download', 'data.json');
			var event = document.createEvent('MouseEvents');
			event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
			link.dispatchEvent(event);
		}
	}
    
	encode(s) {
		var out = [];
		for (var i = 0; i < s.length; i++) {
			out[i] = s.charCodeAt(i);
		}
		return new Uint8Array(out);
	}


	_download() {
		var link = document.createElement('a');
		link.setAttribute('href', this.url);
		link.setAttribute('download', 'img.webp');
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
		link.dispatchEvent(event);
	}

	_setAsCover() {
		this.cover = true;
		store.dispatch(
			updateCurrentInspection({ path: "cover_image_id", value: this.imgId })
		);
	}

	_draw() {
		var dt = document.createElement("inspx-drawing-tool");
		if (this.drawing) {
			dt.drawingIdToLoad = this.imgId;
		} else {
			dt.imageIdToLoad = this.imgId;
		}
		document.body.appendChild(dt);

		this.remove();
	}

	_delete() {
		if (this.drawing) {
			store.dispatch(deleteDrawingById(this.imgId)).then(() => { this.remove(); });
		} else {
			store.dispatch(deletePhotoById(this.imgId)).then(() => { this.remove(); });
		}
	}

	stateChanged() { }
}

window.customElements.define("insp-photo-viewer", InspPhotoViewer);
